import { useEffect } from "react";

export function useBackAsEscape(onEscape) {
  useEffect(() => {
    const handlePopState = (event) => {
      // Re-push immediately to trap and stay on current URL
      window.history.go(1)
      window.focus();
      if (onEscape) onEscape();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [onEscape]);
}